<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
import { detectZoom } from '@/lib/utils';

export default {
  mounted() {
    window.browserZoom = detectZoom();
  }
};
</script>
<style lang="scss">
@import './styles/reset.scss';
@import './styles/element.scss';

#app {
  overflow: hidden;
}
</style>
